module.exports = __webpack_public_path__ + "img/discover.e433cb60.svg";